var render = function render(){var _vm=this,_c=_vm._self._c;return _c('mobile-status-section',{attrs:{"statuses":_vm.statuses,"records":_vm.records,"show-next-contact":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }